import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RiveFile, useRive, useStateMachineInput } from 'rive-react';
import { RootState } from 'store';

// map hex to rive icon state colors
const brandColorsMap = {
  '#6403a2': 1,
  '#c3b0ff': 2,
  '#065829': 3,
  '#0655cd': 4,
  '#000000': 5,
  '#27419C': 6,
};

interface Props {
  riveFile: RiveFile;
  icon: string;
  hovered: boolean;
  selected?: boolean;
  active?: boolean;
  isMenuExpanded?: boolean;
}

export const SideBarMenuIcon: FC<Props> = ({
  riveFile,
  icon,
  hovered,
  selected,
  active,
  isMenuExpanded,
}) => {
  const { rive, RiveComponent } = useRive({
    riveFile,
    stateMachines: 'State Machine 1',
    artboard: icon,
    autoplay: true,
  });
  const hoverInput = useStateMachineInput(rive, 'State Machine 1', 'Hover');
  const colorInput = useStateMachineInput(rive, 'State Machine 1', 'IconColor');
  const { brand, palette } = useSelector(
    (state: RootState) => state.settings.brandConfig.config.theme
  );

  useEffect(() => {
    if (!colorInput) {
      return;
    }

    // get brand color hex from state
    const [, colorKey, shade] = brand.main.match(/^palette-(.*)-(\d+)$/)!;
    const key = colorKey?.replace(/-([a-z])/g, (_, item) => item.toUpperCase());
    const color = palette[key][shade];

    // controling of icons color state
    if (selected || (active && !isMenuExpanded)) {
      colorInput.value = brandColorsMap[color];
    } else {
      colorInput.value = 0;
    }
  }, [colorInput, selected, active, brand.main, isMenuExpanded]);

  useEffect(() => {
    if (hoverInput) {
      hoverInput.value = hovered;
    }
  }, [hoverInput, hovered]);

  return (
    <div>
      <RiveComponent style={{ width: 20, height: 20, pointerEvents: 'none' }} />
    </div>
  );
};
